import { useState } from "react";
import { Dropdown } from "react-bootstrap";

export function LocationDropdown({ id, locations, onUpdate }) {

  const defaultIndex = locations.findIndex((l) => l.id == id);
  const defaultLocation = defaultIndex == -1 ? null : locations[defaultIndex];
  const [currentLocation, setCurrentLocation] = useState(defaultLocation);

  function onLocationUpdate(index) {
    setCurrentLocation(locations[index]);
    onUpdate(locations[index]);
  }

  return (
    <Dropdown key={`locations_dropdown_container`} drop="end">
      <Dropdown.Toggle variant="success" id="dropdown-basic">
        {currentLocation == null ? "Location" : currentLocation.name}
      </Dropdown.Toggle>
      <Dropdown.Menu>
        {
          locations.length > 0
            ? locations.map(function (item, index) {
              return <Dropdown.Item
                key={`locations.${index}_location_drop_down_menu`}
                onClick={() => onLocationUpdate(index)}
                name={item.name}>
                {item.name}
              </Dropdown.Item>;
            })
            : <></>
        }
      </Dropdown.Menu>
    </Dropdown>
  );
}